export const SUCCESS = 'SUCCESS';
export const FAILED = 'FAILED';
